export const FREE_TRIAL_PRICE_MAP = {
    '30': 33.65,
    '90': 34.95,
};
